import { Tabs } from "antd";
import React from "react";
import EdaDescription from "./description/EdaDescription";
import Page from "./tab-page-01/Page";

const IndexOfEda = () => {
  const onChange = (key) => {};

  const items = [
    {
      key: "TAB_PROJECT_INFO",
      label: "Description",
      children: <EdaDescription />,
    },
    {
      key: "TAB_CLIENT",
      label: "Page 01",
      children: (
        <>
          <Page />
        </>
      ),
    },
    {
      key: "TAB_INFRA",
      label: "Page 02",
      children: "Page 02",
    },
  ];
  return (
    <>
      <Tabs centered items={items} onChange={onChange} />
    </>
  );
};

export default IndexOfEda;
